import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = {
  for: "tbox1",
  style: {"padding-bottom":"6px","font-size":"14px","margin-right":"13rem"}
}
const _hoisted_4 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_kbutton = _resolveComponent("kbutton")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_GridLoading)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_k_dialog, {
          key: 1,
          title: _ctx.duplicateStyle,
          onClose: _ctx.toggleDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("duplicateStylePopup.styleName")), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.remaningLength) + "/30", 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass({ errorStyle: _ctx.errorMsg }),
                maxlength: "30",
                id: "tbox1",
                style: {"padding":"2px"},
                name: "tbox1",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCounter($event)))
              }, null, 34), [
                [_vModelText, _ctx.value]
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
            ]),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_kbutton, {
                  class: "save",
                  onClick: _ctx.createDuplicateStyle
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("i", {
                      class: "fas fa-file-alt",
                      style: {"padding-right":"5px"}
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t("duplicateStylePopup.save&Open")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_kbutton, {
                  class: "cancel",
                  onClick: _ctx.toggleDialog
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("i", {
                      class: "fas fa-ban",
                      style: {"padding-right":"5px"}
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t("duplicateStylePopup.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}